export const endPoints = {
  CLIENT_SEND_MESSAGE: '/v1/client/send-messages',
  CLIENT_SEND_MESSAGE_FILTER: '/v1/client/send-message/filter',
  CLIENT_SEND_MESSAGE_FILTER_EXCEL: '/v1/client/send-message/filter/excel',
  CLIENT_MESSAGE_TEMP: '/v1/client-message-temp/',
  PLAY_MOBILE_CONF_ORGINATOR: '/v1/sms-system-conf/originator',
  CLIENT_MESSAGE_TEMP_FIELDS: '/v1/client-message-temp/fields'
};
